import { api } from './axios';
import { PhotoEntity } from '../interfaces/photos';

export const getPhotos = async (eventId: string): Promise<PhotoEntity[]> => {
  const photosQuery = `query getPhotos { 
    photoList (first: 50, where: { eventId: { eq: "${eventId}"}}) { 
      nodes { 
        eventId 
        imageId 
        id 
      } 
    } 
  }`;

  const photos = api
    .post('', {
      query: photosQuery,
      operationName: 'getPhotos'
    })
    .then((res) => res.data.data.photoList.nodes as PhotoEntity[])
    .catch(() => getPhotos(eventId));

  return photos;
};
